import React, { useState } from 'react'
import PaymentMethodPopup from './PaymentMethodPopup';

const PremiumPopup = ({ show, onClose, onNext,onError }) => {
    const [showPaymentPopup, setShowPaymentPopup] = useState(false);
    if (!show) return null;
    
    const nextYear = new Date().getFullYear() + 1;

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" dir='rtl'>
            <div className="bg-white rounded-xl overflow-y-scroll max-h-[80vh] shadow-lg w-full max-w-md relative animate-fadeIn p-6">

                {/* Close */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                >
                    ✕
                </button>

                {/* Title */}
                <h2 className="text-xl font-bold text-blue-700 text-center mb-3">
                    ממונה יקר/ה שלום רב!
                </h2>

                {/* Body text */}
                <p className="text-gray-700 text-sm text-center leading-relaxed mb-4">
                    טרם שילמת דמי חבר שנתיים,
                    <br />
                    תשלום דמי החבר מקנה לכל שנה קלנדרית :
                    {/* המנוי תקף עד <strong>ינואר {nextYear}</strong> וכולל הטבות בלעדיות במהלך השנה. */}
                </p>

                {/* Bullet points */}
                <ul className="text-gray-600 text-sm mb-5 space-y-1 text-right">

                    {/* <li>✔ הנחות לממוני בטיחות פעילים</li>
          <li>✔ תוקף עד ינואר של השנה העוקבת</li>
          <li>✔ רישום מהיר לקורסים ולימי הדרכה</li>
          <li>✔ שמירת סטטוס פעיל במערכת</li> */}
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                            זכאות להשתתפות ב 2 ימי כשירות לבחירתכם בשווי של 100 ₪ כ"א.
                        </span>
                    </li>
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                            השתתפות בימי עיון והכשרות לממונים במחיר מוזל
                        </span>
                    </li>
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                            הוראת קבע פעילה תאפשר את תשלום דמי החבר באופן אוטומטי בתחילת כל שנה
                        </span>
                    </li>
                    {/* <li>✔ זכאות להשתתפות ב 2 ימי כשירות לבחירתכם בשווי של 100 ₪ כ"א.</li>
                    <li>✔ השתתפות בימי עיון והכשרות לממונים במחיר מוזל</li>
                    <li>✔ הוראת קבע פעילה תאפשר את תשלום דמי החבר באופן אוטומטי בתחילת כל שנה</li> */}
                </ul>
                <p className="text-gray-700 text-sm text-center leading-relaxed mb-1">
                    "ביחד נעשה ונצליח"
                    <br />
                    בברכה
                    <br />
                    לשכת ממוני הבטיחות - מקצוענים זה אנחנו
                </p>
                {/* Upgrade button */}
                <button
                    // onClick={() => window.location.href = "/upgrade-membership"}
                    onClick={() => setShowPaymentPopup(true)}
                    className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition shadow"
                >
                    לתשלום לדמי החבר
                </button>

                {/* Later */}
                <button
                    onClick={onClose}
                    className="w-full text-gray-500 text-xs mt-3 underline"
                >
                    לא עכשיו
                </button>

            </div>
            <PaymentMethodPopup
                show={showPaymentPopup}
                onClose={() => setShowPaymentPopup(false)}
                onNext={onNext}
                onError={onError}
                // onPay={(method) => {
                //     if (method === "כרטיס אשראי") {
                //         window.location.href = "/upgrade-membership";
                //     } else {
                //         window.location.href = "/client-paying";
                //     }
                // }}
            />
        </div>
    );
}

export default PremiumPopup